import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, timeout } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Cible {
  id: number;
  nom: string;
}

export interface CiblePayload {
  nom: string;
}

@Injectable({ providedIn: 'root' })
export class CiblesService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/cibles`;
  private readonly requestTimeoutMs = 30000;

  constructor(private readonly http: HttpClient) {}

  list(): Observable<Cible[]> {
    return this.http
      .get<{ items?: Cible[] } | Cible[]>(this.baseUrl)
      .pipe(
        timeout(this.requestTimeoutMs),
        map((response) => {
          if (Array.isArray(response)) {
            return response;
          }
          return Array.isArray(response?.items) ? response.items : [];
        })
      );
  }

  create(payload: CiblePayload): Observable<Cible> {
    return this.http
      .post<Cible>(this.baseUrl, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  update(id: number, payload: CiblePayload): Observable<Cible> {
    return this.http
      .put<Cible>(`${this.baseUrl}/${id}`, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  delete(id: number): Observable<{ deleted: boolean; id: number }> {
    return this.http
      .delete<{ deleted: boolean; id: number }>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }
}
